import './Loading.css';

import React from 'react';

const Loading = () => (
  <div className="split-loading">
    <div className="spinner" />
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/elements/Loading/index.js